import {useState} from "react";

export const useSelectEntries = (availableItems: string[]): [boolean, string[], Function, Function, Function] => {

    const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);

    const toggleSelected = (id: string) => {
        if (selectedItems.findIndex(x => x === id) > -1) {
            setSelectedItems(current => current.filter(x => x !== id));
        } else {
            setSelectedItems(current => [id].concat(current))
        }
        setIsAllSelected(false)
    }

    const toggleAllSelected = (newState: boolean | undefined = undefined) => {
        if (newState === false || isAllSelected) {
            setIsAllSelected(false);
            setSelectedItems([]);
        } else {
            setIsAllSelected(true);
            setSelectedItems(availableItems);
        }
    }

    const isSelected = (id: string) => {
        return selectedItems.findIndex(x => x === id) > -1
    }

    return [isAllSelected, selectedItems, isSelected, toggleSelected, toggleAllSelected]
}
